export const availableErrors = [
  'order_error',
  'server_error',
  'network_error',
  'general_error',
  'action_not_found'
]

export default module
